module.exports = "/assets/data/6ce5b185c4bbb2b80187827b8f6da4e9-PA36.data.json";